
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutLaborDialog extends Common.GridEditorDialog<BranchOutLaborRow> {
        protected getFormKey() { return BranchOutLaborForm.formKey; }
        //protected getIdProperty() { return BranchOutLaborRow.idProperty; }
        protected getLocalTextPrefix() { return BranchOutLaborRow.localTextPrefix; }
        //protected getNameProperty() { return BranchOutLaborRow.nameProperty; }
        //protected getService() { return BranchOutLaborService.baseUrl; }
        protected getDeletePermission() { return BranchOutLaborRow.deletePermission; }
        protected getInsertPermission() { return BranchOutLaborRow.insertPermission; }
        protected getUpdatePermission() { return BranchOutLaborRow.updatePermission; }

        protected form = new BranchOutLaborForm(this.idPrefix);



    }
}